import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const InsaatReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [projectInfo, setProjectInfo] = useState({
    projectName: '',
    clientName: '',
    location: '',
    reportDate: new Date().toISOString().split('T')[0]
  });

  const [materials, setMaterials] = useState([
    { materialName: '', unit: 'kg', quantity: 1, unitPrice: 0, total: 0 }
  ]);

  const [additionalExpenses, setAdditionalExpenses] = useState([
    { expenseItem: '', amount: 0 }
  ]);

  const [notes, setNotes] = useState('');

  // YENİ: Tax Rate (%) opsiyonel
  const [taxRate, setTaxRate] = useState(0);

  useEffect(() => {
    const materialCost = materials.reduce((sum, item) => sum + item.total, 0);
    const additionalCost = additionalExpenses.reduce((sum, item) => sum + item.amount, 0);
    const subtotal = materialCost + additionalCost;
    const tax = taxRate > 0 ? subtotal * (taxRate / 100) : 0;
    const totalCost = subtotal + tax;

    onDataChange({
      ...projectInfo,
      materials,
      additionalExpenses,
      notes,
      materialCost,
      additionalCost,
      subtotal,
      taxRate,
      tax,
      totalCost,
      date: new Date().toLocaleDateString()
    });
  }, [projectInfo, materials, additionalExpenses, notes, taxRate, onDataChange]);

  const handleMaterialChange = (index, field, value) => {
    const newMaterials = [...materials];
    newMaterials[index][field] = value;
    if (field === 'quantity' || field === 'unitPrice') {
      newMaterials[index].total = newMaterials[index].quantity * newMaterials[index].unitPrice;
    }
    setMaterials(newMaterials);
  };

  const handleExpenseChange = (index, field, value) => {
    const newExpenses = [...additionalExpenses];
    newExpenses[index][field] = value;
    setAdditionalExpenses(newExpenses);
  };

  const materialCost = materials.reduce((sum, item) => sum + item.total, 0);
  const additionalCost = additionalExpenses.reduce((sum, item) => sum + item.amount, 0);
  const totalCost = materialCost + additionalCost;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField label="Project Name" name="projectName" value={projectInfo.projectName} onChange={(e) => setProjectInfo({ ...projectInfo, projectName: e.target.value })} placeholder="e.g., Villa Construction" required />
        <InputField label="Client Name" name="clientName" value={projectInfo.clientName} onChange={(e) => setProjectInfo({ ...projectInfo, clientName: e.target.value })} placeholder="Client name" />
        <InputField label="Location" name="location" value={projectInfo.location} onChange={(e) => setProjectInfo({ ...projectInfo, location: e.target.value })} placeholder="Project location" />
        <InputField label="Report Date" name="reportDate" type="date" value={projectInfo.reportDate} onChange={(e) => setProjectInfo({ ...projectInfo, reportDate: e.target.value })} />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Construction Materials</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Material Name</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Unit</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Quantity</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Unit Price</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Total</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {materials.map((material, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={material.materialName} onChange={(e) => handleMaterialChange(index, 'materialName', e.target.value)} placeholder="e.g., Cement, Steel bars" />
                  </td>
                  <td className="p-2">
                    <select className="form-select w-full bg-transparent border-0 focus:ring-0 p-2" value={material.unit} onChange={(e) => handleMaterialChange(index, 'unit', e.target.value)}>
                      {/* <option>kg</option>
                      <option>ton</option>
                      <option>m³</option>
                      <option>pcs</option>
                      <option>bags</option> */}

                    <option>pcs</option>
                    <option>bag</option> 
                     <option>box</option> 
                    <option>pallet</option>
                    <option>pack</option>
                    <option>roll</option>
                    <option>kg</option>
                    <option>ton</option>
                    <option>m³</option> 
                    <option>L</option>      
                    <option>gal</option>     
                    <option>m</option>       
                    <option>ft</option>      
                    <option>m²</option>      
                    <option>sq ft</option>        
                    <option>job</option>     
                    <option>trip</option>   

                    </select>
                  </td>
                  <td className="p-2">
                    <input className="form-input w-20 bg-transparent border-0 focus:ring-0 p-2 text-center" type="number" min="0" step="0.01" value={material.quantity} onChange={(e) => handleMaterialChange(index, 'quantity', parseFloat(e.target.value) || 0)} />
                  </td>
                  <td className="p-2">
                    <input className="form-input w-28 bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={material.unitPrice} onChange={(e) => handleMaterialChange(index, 'unitPrice', parseFloat(e.target.value) || 0)} />
                  </td>
                  <td className="p-2 text-right font-medium text-[#111418] dark:text-gray-100">${material.total.toFixed(2)}</td>
                  <td className="p-2 text-center">
                    <button onClick={() => setMaterials(materials.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={materials.length === 1}>
                      <span className="material-symbols-outlined text-xl">delete</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setMaterials([...materials, { materialName: '', unit: 'kg', quantity: 1, unitPrice: 0, total: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Material</Button>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Additional Expenses (Labor, Transport, etc.)</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Expense Item</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Amount</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {additionalExpenses.map((expense, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={expense.expenseItem} onChange={(e) => handleExpenseChange(index, 'expenseItem', e.target.value)} placeholder="e.g., Labor cost, Transportation" />
                  </td>
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={expense.amount} onChange={(e) => handleExpenseChange(index, 'amount', parseFloat(e.target.value) || 0)} />
                  </td>
                  <td className="p-2 text-center">
                    <button onClick={() => setAdditionalExpenses(additionalExpenses.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={additionalExpenses.length === 1}>
                      <span className="material-symbols-outlined text-xl">delete</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setAdditionalExpenses([...additionalExpenses, { expenseItem: '', amount: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Expense</Button>
        </div>
      </div>

      {/* Tax Rate (%) alanı */}
      <div className="mb-6">
        <InputField
          label="Tax Rate (%) - Optional"
          name="taxRate"
          type="number"
          min="0"
          max="100"
          step="0.1"
          value={taxRate}
          onChange={e => setTaxRate(parseFloat(e.target.value) || 0)}
          placeholder="0 (No Tax)"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Leave 0 for no tax. Example: 16 (Kenya), 18 (Turkey), 5 (UAE)
        </p>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Material Cost</span>
            <span className="font-medium text-[#111418] dark:text-gray-100">${materialCost.toFixed(2)}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Additional Expenses</span>
            <span className="font-medium text-[#111418] dark:text-gray-100">${additionalCost.toFixed(2)}</span>
          </div>
          {/* Sadece taxRate > 0 ise göster */}
          {taxRate > 0 && (
            <div className="flex justify-between items-center">
              <span className="text-gray-600 dark:text-gray-400">Tax ({taxRate}%)</span>
              <span className="font-medium text-[#111418] dark:text-gray-100">${(materialCost + additionalCost) * (taxRate / 100).toFixed(2)}</span>
            </div>
          )}
          <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700">
            <span className="text-lg font-bold text-[#111418] dark:text-gray-100">Total Cost</span>
            <span className="text-lg font-bold text-primary">${(materialCost + additionalCost + (taxRate > 0 ? (materialCost + additionalCost) * (taxRate / 100) : 0)).toFixed(2)}</span>
          </div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Project notes, specifications..." rows={3} />
    </div>
  );
};

export default InsaatReportForm;
